"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThunktankSummary = void 0;
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const setThunktankLoading_1 = __importDefault(require("./setThunktankLoading"));
const sendThunktankQueue_1 = __importDefault(require("./sendThunktankQueue"));
const initThunktank_1 = __importDefault(require("./initThunktank"));
const addThunktankThunk_1 = __importDefault(require("./addThunktankThunk"));
const removeThunktankThunk_1 = __importDefault(require("./removeThunktankThunk"));
const resetThunktankThunk_1 = __importDefault(require("./resetThunktankThunk"));
const useThunktank = (tankSlice, options = {}) => {
    const { queue = false, } = options;
    const dispatch = (0, react_redux_1.useDispatch)();
    const slice = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.thunktank) === null || _a === void 0 ? void 0 : _a[tankSlice]; }, react_redux_1.shallowEqual);
    if (!slice)
        dispatch((0, initThunktank_1.default)(tankSlice));
    const useThunk = (action) => {
        const thunks = (0, react_redux_1.useSelector)((storeState) => {
            var _a, _b;
            return ((_b = (_a = storeState === null || storeState === void 0 ? void 0 : storeState.thunktank) === null || _a === void 0 ? void 0 : _a[tankSlice]) === null || _b === void 0 ? void 0 : _b.thunks);
        }, react_redux_1.shallowEqual);
        let nextAvailable = thunks.findIndex((thunk) => thunk.isDeleted && !thunk.isLoading);
        if (nextAvailable === -1)
            nextAvailable = thunks.length;
        const thunkRef = (0, react_1.useRef)(undefined);
        if (thunkRef.current === undefined) {
            thunkRef.current = nextAvailable;
            dispatch((0, addThunktankThunk_1.default)(tankSlice, nextAvailable));
        }
        const thunkIndex = (0, react_1.useMemo)(() => { var _a; return (_a = thunkRef.current) !== null && _a !== void 0 ? _a : nextAvailable; }, [nextAvailable]);
        const state = (0, react_redux_1.useSelector)((storeState) => {
            var _a, _b, _c;
            return (((_c = (_b = (_a = storeState === null || storeState === void 0 ? void 0 : storeState.thunktank) === null || _a === void 0 ? void 0 : _a[tankSlice]) === null || _b === void 0 ? void 0 : _b.thunks) === null || _c === void 0 ? void 0 : _c[thunkIndex]) || {});
        }, react_redux_1.shallowEqual);
        const scopedAction = (0, react_1.useMemo)(() => action(tankSlice, thunkIndex), [action, thunkIndex]);
        const sendThunk = (0, react_1.useCallback)((...params) => {
            dispatch((0, setThunktankLoading_1.default)(tankSlice, thunkIndex));
            if (queue) {
                dispatch((0, sendThunktankQueue_1.default)(tankSlice, scopedAction(...params)));
            }
            else {
                dispatch(scopedAction(...params));
            }
        }, [scopedAction, thunkIndex]);
        const resetThunk = (0, react_1.useCallback)(() => {
            dispatch((0, resetThunktankThunk_1.default)(tankSlice, thunkIndex));
        }, [thunkIndex]);
        (0, react_1.useEffect)(() => (() => {
            dispatch((0, removeThunktankThunk_1.default)(tankSlice, thunkIndex));
        }), [thunkIndex]);
        return [state, sendThunk, resetThunk];
    };
    return useThunk;
};
const useThunktankSummary = (tankSlice) => {
    const isLoading = (0, react_redux_1.useSelector)((storeState) => {
        var _a, _b;
        return ((((_b = (_a = storeState === null || storeState === void 0 ? void 0 : storeState.thunktank) === null || _a === void 0 ? void 0 : _a[tankSlice]) === null || _b === void 0 ? void 0 : _b.thunks) || [])
            .map((thunk) => thunk.isLoading)
            .reduce((accum, bool) => accum || bool, false));
    }, react_redux_1.shallowEqual);
    return { isLoading };
};
exports.useThunktankSummary = useThunktankSummary;
exports.default = useThunktank;
